import angular from 'angular'
import uiRouter from '@uirouter/angularjs'

export default angular.module('backoffice.dashboard', [
  uiRouter
])



// WEBPACK FOOTER //
// ./src/dashboard/module.js